






import Vue from 'vue'

export default Vue.extend({
  name: 'StopButton',

  props: {
    isPlaying: {
      type: Boolean,
      required: true,
    },
    isCountingDown: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    /**
     * 再生
     */
    stopMusic () {
      this.$emit('stopMusic')
    },
  },
})
